import { render, staticRenderFns } from "./WhyChargedTax.vue?vue&type=template&id=46ee226d&scoped=true"
import script from "./WhyChargedTax.vue?vue&type=script&lang=js"
export * from "./WhyChargedTax.vue?vue&type=script&lang=js"
import style0 from "./WhyChargedTax.vue?vue&type=style&index=0&id=46ee226d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee226d",
  null
  
)

export default component.exports